import { render, staticRenderFns } from "./crud-date.vue?vue&type=template&id=30f08fce&"
import script from "./crud-date.vue?vue&type=script&lang=js&"
export * from "./crud-date.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports